"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var SVG = function SVG(props) {
  return react_1["default"].createElement("svg", {
    className: props.className,
    height: props.height,
    width: props.width,
    viewBox: '0 0 347.14 94.32',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, react_1["default"].createElement("g", {
    "data-name": 'Layer 2'
  }, react_1["default"].createElement("g", {
    "data-name": 'Layer 1'
  }, react_1["default"].createElement("path", {
    d: 'M38.43,93,10.61,64.08V93H0V1.6H10.61V59L37,32H50.63L21.47,61.52,51.6,93Z'
  }), react_1["default"].createElement("path", {
    d: 'M62.88,13.82a7.14,7.14,0,1,1,14.27,0,7.14,7.14,0,0,1-14.27,0ZM64.71,32H75.32V93H64.71Z'
  }), react_1["default"].createElement("path", {
    d: 'M148.37,55.54V93H137.76V56.15c0-10-5.73-15.62-15.13-15.62-9.76,0-17.69,5.73-17.69,20.13V93H94.33V32h10.61v8.78c4.51-7.2,11.22-10.37,19.76-10.37C139,30.41,148.37,39.93,148.37,55.54Z'
  }), react_1["default"].createElement("path", {
    d: 'M161.86,62.76c0-18,12-31.56,29.16-31.56,7.8,0,14.88,3.48,19,9.12V8.16L198.82,4.68V4l17.76-4V89.64h9.48v1.8L210,93.84V84.6c-4.2,6-11.64,9.72-19.68,9.72C173.62,94.32,161.86,81.24,161.86,62.76Zm31.32,28.08A21.57,21.57,0,0,0,210,83.28V41.88A21,21,0,0,0,193.3,34.2c-14.52,0-23.88,12.24-23.88,28.44C169.42,78.6,178.78,90.84,193.18,90.84Z'
  }), react_1["default"].createElement("path", {
    d: 'M240.18,69.24V36.12l-9.24-1.68V32.76h15.84v35.4c0,15.84,5,22,16.08,22,10.08,0,18-7,18-22.08V36.12l-9.12-1.68V32.76h15.72V89.64h9.6v1.8l-16.2,2.4V76.2c-2.4,12.72-11,18.12-21.12,18.12C246.42,94.32,240.18,86.88,240.18,69.24Z'
  }), react_1["default"].createElement("path", {
    d: 'M307.42,91.2l5.16-.24c3.24-.12,4.2-.6,4.2-3V40l-9.36-3.48v-.72l16-4V50.52c2.76-13.92,12-18.6,22.92-18.6h.84V39l-3.48-.24c-15-1.08-20.28,7.56-20.28,18.36V88c0,2.4,1,2.88,4.68,3l7.56.24V93h-28.2Z'
  }))));
};

exports["default"] = SVG;
/* eslint-enable */